import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "settings-section" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "actions"
}
const _hoisted_4 = ["disabled"]

import { ref, computed, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EnvironmentSettings',
  props: {
    initialEnvironment: {},
    isHost: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["update-environment"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const localEnviron = ref(props.initialEnvironment);

watch(() => props.initialEnvironment, (newVal) => {
  localEnviron.value = newVal;
});

const hasChanges = computed(() => localEnviron.value !== props.initialEnvironment);

const applyChanges = () => {
  emit('update-environment', localEnviron.value);
};

const resetChanges = () => {
  localEnviron.value = props.initialEnvironment;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "section-title" }, "Сеттинг Игры", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "section-description" }, " Опишите мир, в котором происходит игра. Ведущий будет использовать это для создания атмосферы. ", -1)),
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localEnviron).value = $event)),
      class: "form-input environment-input",
      maxlength: "300",
      placeholder: "Например: Гангстерский Чикаго 30-х",
      disabled: !_ctx.isHost,
      rows: "3"
    }, null, 8, _hoisted_2), [
      [_vModelText, localEnviron.value]
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isHost && hasChanges.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "btn",
                onClick: applyChanges,
                disabled: _ctx.isLoading
              }, " Применить ", 8, _hoisted_4),
              _createElementVNode("button", {
                class: "btn btn-outline",
                onClick: resetChanges
              }, " Сбросить ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})